import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrCardComponent } from './components/fr-card/fr-card.component';
import { MatCardModule } from '@angular/material/card';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule
  ],
  declarations: [FrCardComponent],
  exports: [FrCardComponent]
})
export class FrCardModule { }
